const ProjectTypeEnum = {
  TNM: 'Time and Material',
  FP: 'Fixed price',
  INTERNAL: 'Internal',
  MAINTENANCE: 'Maintenance',
  OTHER: 'Other',

  };

export default ProjectTypeEnum;